<template>
    <div>
        <div>
            <div>
                <div class="search-bar">
                    <!-- <img src="@/assets/img/job-seeker/jam_search.svg" class="search-icon" height="20" alt="Search" /> -->
                    <el-input data-testid="directions-96" v-model="filter.text" class="job-board__search"
                        placeholder="Enter Job Title" clearable @input="debouncedUpdateLocalStorage" @clear="clearText">
                        <template #prefix>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                                    stroke="#484848" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M22 22L20 20" stroke="#484848" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </template>
                    </el-input>
                    <button class="filter-button" data-testid="directions-97" @click="toggleFilterOptions">
                        <img src="@/assets/img/job-seeker/setting-inactive.svg" />
                        <span v-if="countFilters() > 0">{{ countFilters() }}</span>
                    </button>
                </div>

            </div>

            <!-- Search results -->

            <div v-if="initialIsLoading">
                <job-listing-skeleton :skeletonCount="7" />
            </div>
            <div class="search-results" v-else>
                <div class="job-results" v-if="jobs.length > 0">
                    <browse-job-item-card :jobs="jobs" @job-removed="removeJob"
                        @job-favorite="updateJobFavorite"></browse-job-item-card>
                    <div v-if="isLoading" class="loading-animation">
                        <ion-spinner name="dots"></ion-spinner>
                    </div>
                </div>
                <div v-else>
                    <div class="search_jobs_header no-results-job-listing">
                        <img :src="require(`@/assets/img/illustrations/no-result.svg`)" alt="" />
                        <div class="main_title">No Jobs!</div>
                        <div class="main_text">
                            No jobs were found!
                        </div>
                    </div>
                    <p class="no-results"></p>
                </div>

            </div>
            <div id="bottomBrowseJobObserver"></div>

        </div>
    </div>
    <el-drawer title="Job Filters" v-model="modalCreateVisible" :close-on-click-modal="true"
        :destroy-on-close="true" @close="closeCreateWishlistModal" :append-to-body="true" :direction="'btt'">
        <Filter :modalCreateVisible="modalCreateVisible" @job-filter="updateJobsWithFilters"
            @update:modalCreateVisible="updateModalVisibility" />
    </el-drawer>
</template>

<script>
import { useStore } from "vuex";
// import {
//     useRouter,
// } from "vue-router";
import { onMounted, ref, inject, watch, onUnmounted } from 'vue';
import { addIcons } from 'ionicons';
import { arrowBackOutline } from 'ionicons/icons';
import { IonSpinner } from '@ionic/vue';
import BrowseJobItemCard from './Cards/BrowseJobItemCard.vue';
import JobListingSkeleton from "@/components/JobListingSkeleton/JobListingSkeleton.vue";
import debounce from 'lodash/debounce';
import Filter from "./Filters/BrowseJobFilterPage.vue"
import { trackEvent } from '@/helpers/analytics/ga.js'; // eslint-disable-line no-unused-vars
addIcons({
    'arrow-back-outline': arrowBackOutline,
});

export default {
    components: {
        BrowseJobItemCard,
        IonSpinner,
        JobListingSkeleton,
        Filter
    },
    setup() {
        const $store = useStore();
        // const $router = useRouter();
        const setPageClassGlobal = inject('setPageClassGlobal');
        // const tabBrowseClicked = ref(false);
        const jobs = ref([]);
        const initialIsLoading = ref(false);
        const currentPage = ref(1); // Track the current page
        const isLoading = ref(false); // Track if data is currently being loaded
        let observer = null;
        const modalCreateVisible = ref(false);

        const filter = ref(JSON.parse(localStorage.getItem('jobSeekerBrowseFilterObject')) ? JSON.parse(localStorage.getItem('jobSeekerBrowseFilterObject')) : {
            text: '',
            jobType: '',
            federalPharmacistSupport: '',
            jobLocation: '',
            taggedSkills: [],
            // rate: {
            //     type: '',
            //     value: 0
            // }
        });

        const toggleFilterOptions = () => {
            // $router.push({
            //     name: "job_seeker_browse_filter",// Assuming job object has an 'id' property
            // });
            modalCreateVisible.value = true;
        };

        // watchEffect(() => {
        //     if (props.isActive && tabBrowseClicked.value === false) {
        //         // Run your initial fetch job data function
        //         initialFetchJobData();

        //         // Update tabBrowseClicked to true so that watchEffect doesn't run again
        //         tabBrowseClicked.value = true;
        //     }
        // });

        // // Reset tabBrowseClicked when isActive changes to false
        // watchEffect(() => {
        //     if (!props.isActive) {
        //         tabBrowseClicked.value = false;
        //     }
        // });

        const customSortJobsByFavAndFavDate = (a, b) => {
            // Check if one job is favorite and the other is not
            if (a.favorite && !b.favorite) {
                return -1; // a comes before b
            } else if (!a.favorite && b.favorite) {
                return 1; // b comes before a
            } else if (a.favorite && b.favorite) {
                // If both are favorite, compare by markedFavoriteAt date
                if (a.markedFavoriteAt && b.markedFavoriteAt) {
                    const dateA = new Date(a.markedFavoriteAt);
                    const dateB = new Date(b.markedFavoriteAt);
                    return dateB - dateA; // newer marked favorite comes first
                } else if (a.markedFavoriteAt && !b.markedFavoriteAt) {
                    return -1; // a comes before b as it has a marked favorite date
                } else if (!a.markedFavoriteAt && b.markedFavoriteAt) {
                    return 1; // b comes before a as it has a marked favorite date
                }
            }
            // If both are not favorite, maintain the original order - order by published date 
            const publishDateA = new Date(a.publishedAt);
            const publishDateB = new Date(b.publishedAt);
            return publishDateB  - publishDateA;
        }


        const initialFetchJobData = async () => {
            return new Promise((resolve) => {
                initialIsLoading.value = true;
                console.log('initialllllllll')
                $store.dispatch("JOB_SEEKER_BROWSE_JOB_LIST", { page: currentPage.value, filter: filter.value, associationId: localStorage.getItem('association_id') ? localStorage.getItem('association_id') : null })
                    .then((response) => {
                        let jobFetchResult = response.data;
                        console.log("🚀 ~ .then ~ jobFetchResult:", jobFetchResult)
                        const jobsData = jobFetchResult.map(job => ({
                            id: job.id,
                            title: job.title,
                            poster: job.pharmacy.name,
                            image: job.pharmacy.image,
                            location: job.location,
                            payRate: job.payRate,
                            payInterval: job.payInterval,
                            category: job.category,
                            type: job.type,
                            description: job.description,
                            shortDescription: job.shortDescription,
                            jobPharmacy: job.pharmacy,
                            published: job.publishedDate,
                            favorite: job.favorite,
                            markedFavoriteAt: job.markedFavoriteAt,
                            publishedAt: job.publishedAt,
                            expiryDate: job.expiryDate,
                            federalPharmacistSupport:job.federalPharmacistSupport ? job.federalPharmacistSupport : null,
                            hideSalary: job.hideSalary ? job.hideSalary : false,
                        }));

                        // Assign the mapped data to the jobs ref variable
                        jobs.value = jobsData;
                        jobs.value.meta = response.meta;
                        console.log("🚀 ~ .then1111 ~ jobs.value:", jobs.value)
                        initialIsLoading.value = false;
                        trackEvent('job_list_viewed', { user_type: 'logged_in', job_count: jobsData.length });
                        resolve(response);
                        jobs.value.sort(customSortJobsByFavAndFavDate)
                    });
            });
        };
        const loadMoreJobs = async () => {
            console.log("loaddddddddd moreeeee")
            // Prevent loading more data if already loading or if reached last page
            console.log("🚀 ~ loadMoreJobs ~ isLoading:", jobs.value)
            if (isLoading.value || currentPage.value >= jobs.value.meta?.lastPage) return;
            console.log("🚀 ~ loadMoreJobs ~ currentPage:", currentPage)
            isLoading.value = true;
            try {
                const response = await $store.dispatch("JOB_SEEKER_BROWSE_JOB_LIST", { page: currentPage.value + 1, filter: filter.value, associationId: localStorage.getItem('association_id') ? localStorage.getItem('association_id') : null, hideLoading: true, });
                const newJobs = response.data.map(job => ({
                    id: job.id,
                    title: job.title,
                    poster: job.pharmacy.name,
                    image: job.pharmacy.image,
                    location: job.location,
                    payRate: job.payRate,
                    payInterval: job.payInterval,
                    category: job.category.category,
                    type: job.type,
                    description: job.description,
                    shortDescription: job.shortDescription,
                    jobPharmacy: job.pharmacy,
                    published: job.publishedDate,
                    favorite: job.favorite,
                    markedFavoriteAt: job.markedFavoriteAt,
                    publishedAt: job.publishedAt,
                    expiryDate: job.expiryDate,
                    federalPharmacistSupport:job.federalPharmacistSupport ? job.federalPharmacistSupport : null,
                    hideSalary: job.hideSalary ? job.hideSalary : false,
                }));
                jobs.value = [...jobs.value, ...newJobs];
                // jobs.value = jobs.value.concat(newJobs);
                jobs.value.meta = response.meta;
                jobs.value.sort(customSortJobsByFavAndFavDate)
                console.log("🚀 ~ loadMoreJobs ~ jobs2323232:", jobs)
                currentPage.value++;
            } catch (error) {
                console.error("Error loading more jobs:", error);
            } finally {

                isLoading.value = false;
            }


        };


        const countFilters = () => {
            let count = 0;
            console.log("filter vlaue: ", filter.value)
            for (const key in filter.value) {
                const value = filter.value[key];
                if (value != null && value !== '' && !(Array.isArray(value) && value.length === 0)) {
                    if (typeof value === 'object' && Object.keys(value).length === 0) {
                        continue; // Skip empty objects
                    }
                    if (key === 'rate' && value.type === '') {
                        continue; // Skip empty rate object
                    }
                    count++;
                }
            }
            // Adjust count if text, jobType, and jobLocation are all empty
            // if (filter.value.text === '' && filter.value.jobType === '' && filter.value.jobLocation === '') {
            //     count--;
            // }
            return count;
        };


        // Function to update localStorage
        const updateLocalStorage = () => {
            console.log("🚀 ~ updateLocalStorage ~ selectedValues.value", filter.value)
            localStorage.setItem('jobSeekerBrowseFilterObject', JSON.stringify(filter.value));
            currentPage.value = 1;
            initialFetchJobData();
        };
        const debouncedUpdateLocalStorage = debounce(updateLocalStorage, 500); // Adjust the debounce delay as needed
        // Watch for changes in filter and update localStorage accordingly
        watch(filter, () => {
            updateLocalStorage();

        });

        const clearText = () => {
            console.log('clear text')
            filter.value.text = '';
            currentPage.value = 1;
            debouncedUpdateLocalStorage();
            // Update local storage to remove only the 'text' property from 'jobSeekerBrowseFilterObject'
            const storedValues = JSON.parse(localStorage.getItem('jobSeekerBrowseFilterObject'));
            if (storedValues) {
                delete storedValues.text;
                localStorage.setItem('jobSeekerBrowseFilterObject', JSON.stringify(storedValues));
            }
            initialFetchJobData();
        };

        const observeIntersection = () => {
            const handleIntersection = (entries) => {
                console.log("entries", entries);
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        loadMoreJobs();
                    }
                });
            };

            observer = new IntersectionObserver(handleIntersection, {
                root: null,
                rootMargin: '500px 0px',
                threshold: 0.1,
            });

            observer.observe(document.getElementById('bottomBrowseJobObserver'));
        };

        const unobserveIntersection = () => {
            if (observer) {
                observer.disconnect();
            }
        };

        const removeJob = (jobId) => {
            // Update jobs array by removing the item at the specified index
            const index = jobs.value.findIndex(job => job.id === jobId);
            if (index !== -1) {
                jobs.value.splice(index, 1);
            }
        }
        
        const updateJobFavorite = (jobId, jobPost) => {
            jobs.value.filter(job => {
                if (job.id === jobId) {
                    job.favorite = jobPost.favorite;
                    job.markedFavoriteAt = jobPost.markedFavoriteAt;
                }
            });
            jobs.value.sort(customSortJobsByFavAndFavDate)
        }

        const updateJobsWithFilters = () => {
            filter.value = JSON.parse(localStorage.getItem('jobSeekerBrowseFilterObject')) ? JSON.parse(localStorage.getItem('jobSeekerBrowseFilterObject')) : {
            text: '',
            jobType: '',
            federalPharmacistSupport: '',
            jobLocation: '',
            taggedSkills: [],
            // rate: {
            //     type: '',
            //     value: 0
            // }
        };
            // countFilters();
            loadMoreJobs();
        }

        onMounted(() => {
            setPageClassGlobal('global_job_seeker_browse_page');
            // if (props.isActive) {
                observeIntersection();
                initialFetchJobData();
            // }
        });

        onUnmounted(() => {
            unobserveIntersection();
        });

        const updateModalVisibility = (value) => {
            modalCreateVisible.value = value;
        };
        return {
            jobs,
            isLoading,
            filter,
            toggleFilterOptions,
            updateLocalStorage,
            clearText,
            countFilters,
            initialIsLoading,
            debouncedUpdateLocalStorage,
            removeJob,
            updateJobFavorite,
            modalCreateVisible,
            updateModalVisibility,
            updateJobsWithFilters
        };
    },
};
</script>
